import commonDeDe from "./de-DE/common.json.js";
import glossaryDeDe from "./de-DE/glossary.json.js";
import translationDeDe from "./de-DE/translation.json.js";
import commonEnUs from "./en-US/common.json.js";
import glossaryEnUs from "./en-US/glossary.json.js";
import translationEnUs from "./en-US/translation.json.js";
import commonEsEs from "./es-ES/common.json.js";
import glossaryEsEs from "./es-ES/glossary.json.js";
import translationEsEs from "./es-ES/translation.json.js";
import commonFrFr from "./fr-FR/common.json.js";
import glossaryFrFr from "./fr-FR/glossary.json.js";
import translationFrFr from "./fr-FR/translation.json.js";
import commonItIt from "./it-IT/common.json.js";
import glossaryItIt from "./it-IT/glossary.json.js";
import translationItIt from "./it-IT/translation.json.js";
import commonPtBr from "./pt-BR/common.json.js";
import glossaryPtBr from "./pt-BR/glossary.json.js";
import translationPtBr from "./pt-BR/translation.json.js";
import commonTrTr from "./tr-TR/common.json.js";
import glossaryTrTr from "./tr-TR/glossary.json.js";
import translationTrTr from "./tr-TR/translation.json.js";
const resources = {
  "de-DE": {
    common: commonDeDe,
    glossary: glossaryDeDe,
    translation: translationDeDe
  },
  "en-US": {
    common: commonEnUs,
    glossary: glossaryEnUs,
    translation: translationEnUs
  },
  "es-ES": {
    common: commonEsEs,
    glossary: glossaryEsEs,
    translation: translationEsEs
  },
  "fr-FR": {
    common: commonFrFr,
    glossary: glossaryFrFr,
    translation: translationFrFr
  },
  "it-IT": {
    common: commonItIt,
    glossary: glossaryItIt,
    translation: translationItIt
  },
  "pt-BR": {
    common: commonPtBr,
    glossary: glossaryPtBr,
    translation: translationPtBr
  },
  "tr-TR": {
    common: commonTrTr,
    glossary: glossaryTrTr,
    translation: translationTrTr
  }
};
export {
  resources as default
};
